export default __webpack_public_path__ + "static/media/partners16.226de10f.png";